import { useState } from 'react';
import { Button } from '@mui/material';
import type { Area } from 'react-easy-crop';
import { BaseDialog } from '@/components/shared/base-dialog';
import { ImageCropper } from '@/components/shared/image-cropper';

type ImageCropperDialogProps = {
  image: string;
  onClose: () => void;
  onCrop: ({
    cropArea,
    originalImage,
  }: {
    cropArea: Area;
    originalImage: string;
  }) => void;
  cropShape?: 'round' | 'rect';
  aspectRatio?: number;
};

export const ImageCropperDialog = ({
  image,
  onClose,
  onCrop,
  cropShape = 'round',
  aspectRatio = 1,
}: ImageCropperDialogProps) => {
  const [cropAreaPixels, setCropAreaPixels] = useState<Area | null>(null);

  const handleSave = () => {
    if (!cropAreaPixels) {
      throw new Error('crop area is null');
    }

    // Pass both the original image and crop coordinates
    onCrop({ cropArea: cropAreaPixels, originalImage: image });
    onClose();
  };

  return (
    <BaseDialog
      actionsComponent={
        <>
          <Button
            disabled={!cropAreaPixels}
            onClick={handleSave}
            variant="contained"
          >
            Salvar nova imagem
          </Button>
          <Button onClick={onClose} variant="outlined">
            Fechar
          </Button>
        </>
      }
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      open={true}
      title="Recortar imagem"
    >
      <ImageCropper
        image={image}
        onCrop={setCropAreaPixels}
        cropShape={cropShape}
        aspectRatio={aspectRatio}
      />
    </BaseDialog>
  );
};
